import style from '~style/variables.scss'

export const getColorFromName = (name) => {
	return style[name]
}

export type TIconColor = 'dark' | 'light' | 'blue'
